
Core.CheckoutAvoidDuplicate = function(elem) {

    /*


        DATASET


     */

    function hasDataset(elem, name) {
        return elem &&
               elem.dataset &&
               typeof elem.dataset[name] !== 'undefined';
    }

    function warnData(name) {
        console.warn('CheckoutAvoidDuplicate data for ' + name + ' missing');
        return;
    }

    function getDataset(elem, name) {
        return hasDataset(elem, name)
                    ? elem.dataset[name]
                    : warnData(name);
    }


    /*


        TMPL


     */

    function counterTmlp(data) {
        return `<div class="checkoutAvoidDuplicateWarning--largeAnimation">
                <div class="checkoutAvoidDuplicateWarning--large">
                    <div class="checkoutAvoidDuplicateWarning--largeImg">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style="width: 36px; color: #6c6c6e;">
                            <path fill="currentColor" d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"/>
                        </svg>
                    </div>

                    <div class="pt-2">
                        <b>WARNING</b><br>
                        <span>Another approver is looking this order</span>
                    </div>
                </div>
            </div>

            <div class="checkoutAvoidDuplicateWarning--smallAnimation">
                <div class="checkoutAvoidDuplicateWarning--small">
                    <div class="checkoutAvoidDuplicateWarning--smallImg">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style="width: 36px; color: #6c6c6e;">
                            <path fill="currentColor" d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"/>
                        </svg>
                    </div>
                    <div class="checkoutAvoidDuplicateWarning--smallLabel">Warning</div>
                </div>
            </div>
        `;
    }

    var el = {
        elem: elem,
        portalCheckout: document.querySelector('#portal-checkout'),
    };

    var data = {
        orderNumber: getDataset(elem, 'orderNumber'),
        dashboardUrl: getDataset(elem, 'dashboardUrl'),
    };



    // Methods
    var m = {
        init: function() {
            if (typeof data.orderNumber === 'undefined') {
                return;
            }

            m.boot();
        },


        boot: function() {
            document.addEventListener('aidacare.warningshow', function() { m.showWarning(); m.calcWarningPosition(); });
            document.addEventListener('aidacare.warninghide', m.hideWarning);
            document.addEventListener('aidacare.orderchanged', function() { m.showOrderChangedBanner();  m.closeAccordions(); });

            document.addEventListener('delivery-counter:show', m.calcWarningPosition);
            document.addEventListener('delivery-counter:hide', m.calcWarningPosition);

            m.connect();
        },

        connect: function() {
            var connection = $.hubConnection();
            var proxy = connection.createHubProxy('aidacareHub');

            proxy.on('multipleUsers', m.fire('aidacare.warningshow'));
            proxy.on('singleUser', m.fire('aidacare.warninghide'));
            proxy.on('orderChanged', m.fire('aidacare.orderchanged'));
            proxy.on('orderChanged', m.fire('aidacare.clearcart'));


            connection.start()
                .done(function(){ console.log('Now connected, connection ID=' + connection.id); })
                .fail(function(){ console.log('Could not connect'); });
        },

        fire: function(eventName) {
            return function(orderNumber, message) {
                console.log(orderNumber);
                console.log(message);

                if (orderNumber !== data.orderNumber) {
                    return;
                }

                var ev = new CustomEvent(eventName);
                document.dispatchEvent(ev);
            }
        },


        /*


            Order Changed Banner


         */

        showOrderChangedBanner: function() {
            if (m.hasOrderChangedBanner()) {
                return;
            }

            var banner = m.getOrderChangedBanner();
            el.portalCheckout.prepend(banner);
        },

        getOrderChangedBanner: function() {
            var banner = document.createElement('div');
            banner.classList.add('checkoutAvoidDuplicate-orderChanged');
            banner.innerHTML = `<b>Attention:</b> The order has already changed, please go to the <a href="${data.dashboardUrl}">dashboard</a> and check for the changes`;

            return banner;
        },

        hasOrderChangedBanner: function() {
            return document.querySelector('.checkoutAvoidDuplicate-orderChanged') !== null;
        },

        closeAccordions: function() {
            var accordionItems = document.querySelectorAll('.portal-checkout__accordion-item');

            function isNotNull(item) {
                return ! (item == null);
            }

            function removeOpenPassedClasses(item) {
                item.classList.remove('open');
                item.classList.remove('passed');
            }

            Array
                .from(accordionItems)
                .filter(isNotNull)
                .forEach(removeOpenPassedClasses)
        },

        hasWarning: function() {
            return document.querySelector('.checkoutAvoidDuplicateWarning') !== null;
        },

        hasDeliveryCounterVisible: function() {
            var delivery = document.querySelector('.deliveryCounter');

            return delivery && (delivery.style.display === 'block');
        },

        calcWarningPosition: function() {
            if (! m.hasWarning()) {
                return;
            }

            var warn = document.querySelector('.checkoutAvoidDuplicateWarning');

            m.hasDeliveryCounterVisible()
                ? (warn.style.bottom = 'calc(32px + 87px)')
                : (warn.style.bottom = '16px');
        },

        showWarning: function() {
            if (m.hasWarning()) {
                return;
            }

            var warn = document.createElement('div');
            warn.classList.add('checkoutAvoidDuplicateWarning');
            warn.classList.add('checkoutAvoidDuplicateWarning--yellow');
            warn.classList.add('checkoutAvoidDuplicateWarning--showSmall');

            warn.innerHTML = counterTmlp();

            function swapClasses(e) {
                e.currentTarget.classList.toggle('checkoutAvoidDuplicateWarning--showLarge');
                e.currentTarget.classList.toggle('checkoutAvoidDuplicateWarning--showSmall');
            }

            warn.addEventListener('click', swapClasses);

            document.body.prepend(warn);
        },

        hideWarning: function() {
            var el = document.querySelector('.checkoutAvoidDuplicateWarning');
            el && el.remove();
        },
    };

    return m;

};
